var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "signature-container", attrs: { id: "signature" } },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _c("div", { staticClass: "signature-header" }, [
          _c("h2", [_vm._v("Mail İmzası")]),
          _vm._v(" "),
          _c("p", { staticClass: "signature-description" }, [
            _vm._v(
              "E-postalarınıza otomatik olarak eklenecek imzanızı burada düzenleyebilirsiniz."
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mail-selection-container" }, [
          _c(
            "div",
            { staticClass: "mail-selection" },
            [
              _c("label", [_vm._v("E-posta Adresi Seçimi")]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticClass: "mail-select",
                  attrs: { placeholder: "E-posta adresinizi seçiniz" },
                  on: { change: _vm.onMailSelect },
                  model: {
                    value: _vm.selectedMail,
                    callback: function ($$v) {
                      _vm.selectedMail = $$v
                    },
                    expression: "selectedMail",
                  },
                },
                _vm._l(_vm.mailOptions, function (mail) {
                  return _c(
                    "a-select-option",
                    { key: mail._id, attrs: { value: mail.mail } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(mail.mail) +
                          "\n                    "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.selectedMail
          ? _c(
              "div",
              { staticClass: "auto-add-container" },
              [
                _c(
                  "a-checkbox",
                  {
                    attrs: { disabled: _vm.editorContent === "" },
                    on: { change: _vm.changeSignatureAuto },
                    model: {
                      value: _vm.isAutoAdd,
                      callback: function ($$v) {
                        _vm.isAutoAdd = $$v
                      },
                      expression: "isAutoAdd",
                    },
                  },
                  [_vm._v("\n                Otomatik Ekle\n            ")]
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  {
                    attrs: { placement: "top" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _vm._v(
                                "Bu seçenek işaretlendiğinde, bu imza yeni e-postalarınıza otomatik olarak eklenecektir."
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3426192361
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c("a-icon", {
                      staticClass: "info-icon",
                      attrs: { type: "info-circle" },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.selectedMail
          ? _c(
              "div",
              { staticClass: "signature-editor-container" },
              [
                _c("h3", [_vm._v("İmza Düzenleyici")]),
                _vm._v(" "),
                _c("MailEditor", {
                  ref: "mailEditor",
                  attrs: { inlineTextOnly: true, hideAIAssistant: true },
                  on: { input: _vm.onEditorChange },
                  model: {
                    value: _vm.editorContent,
                    callback: function ($$v) {
                      _vm.editorContent = $$v
                    },
                    expression: "editorContent",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.selectedMail
          ? _c(
              "div",
              { staticClass: "action-buttons" },
              [
                _c(
                  "SupsisButton",
                  { attrs: { primary: "" }, on: { click: _vm.saveSignature } },
                  [_vm._v("\n                Kaydet\n            ")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }